__webpack_require__.p = "/periodic_table_AI/";